import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { AdminService } from '../../admin.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-upload-report-template',
  templateUrl: './upload-report-template.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [MatSelectModule, FormsModule, MatButtonModule, MatInputModule],
})
export class UploadReportTemplateComponent {
  private admnSrvc = inject(AdminService);

  @Output() toggleLoading = new EventEmitter();
  @Input() reportTemplates;
  selectedUpdateReportNewTemplate: string;
  selectedUpdateReportStatus: string;
  selectedUpdateReportStatusClass: string;
  selectedUpdateReportTemplate: string;

  updateReportTemplate() {
    this.toggleLoading.emit();
    this.selectedUpdateReportStatus = null;
    this.selectedUpdateReportStatusClass = null;

    const data = `{"test": "UpdateTemplate", "name": "${this.selectedUpdateReportTemplate}"}\n#data template\n${this.selectedUpdateReportNewTemplate}`;

    this.admnSrvc.uploadReportTemplate(data).subscribe({
      next: res => {
        this.toggleLoading.emit();
        this.selectedUpdateReportStatus = `Success. ${res.data}.`;
        this.selectedUpdateReportStatusClass = 'success';
      },
      error: catchError(err => {
        this.toggleLoading.emit();
        this.selectedUpdateReportStatus = err;
        this.selectedUpdateReportStatusClass = 'failure';
        return throwError(() => err.error || 'Server error');
      }),
    });
  }
}
